module.exports = __webpack_public_path__ + "img/other-logo-vista.a710158f.png";